window.setTimeout(function () {
  var alerts = document.querySelectorAll('.alert-auto-dismissible');
  alerts.forEach(function (el) {
    if (!document.contains(el)) return;
    el.style.transition = 'opacity 0.5s ease';
    el.style.opacity = '0';
    setTimeout(function () {
      if (!document.contains(el)) return;
      el.style.transition = 'max-height 0.5s ease, margin 0.5s ease, padding 0.5s ease';
      el.style.overflow = 'hidden';
      el.style.maxHeight = el.scrollHeight + 'px';
      void el.offsetHeight;
      el.style.maxHeight = '0';
      el.style.marginTop = '0';
      el.style.marginBottom = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';

      var removed = false;
      function remove() {
        if (removed) return;
        removed = true;
        if (el.parentNode) el.parentNode.removeChild(el);
      }

      el.addEventListener('transitionend', function handler(e) {
        if (e.target !== el) return;
        el.removeEventListener('transitionend', handler);
        remove();
      });
      setTimeout(remove, 600);
    }, 500);
  });
}, 5000);
